export default __webpack_public_path__ + "static/media/icon-RMS.2b2ce038.svg";